/**
 * Labels for coach list cards — always CoachChatList.* (modal namespace).
 */
export function buildCoachListLabels(t) {
  return {
    moreInfo: t('CoachChatList.more_info', {
      defaultValue: 'Expand to View Bio',
    }),
    showLess: t('CoachChatList.show_less', { defaultValue: 'View Less' }),
    video: t('CoachChatList.video_chat', { defaultValue: 'Video Chat' }),
    text: t('CoachChatList.text_chat', { defaultValue: 'Text Chat' }),
    audio: t('CoachChatList.audio_chat', { defaultValue: 'Audio Chat' }),
    currentlyBusy: t('CoachChatList.currently_busy', {
      defaultValue: 'Currently in a chat',
    }),
    yearsExperience: t('CoachChatList.years_experience', {
      defaultValue: 'years of experience',
    }),
    supportedClients: (count) =>
      t('CoachChatList.supported_clients', {
        count,
        defaultValue: `Supported ${count} clients`,
      }),
    satisfactionRating: (rating) =>
      t('CoachChatList.satisfaction_rating', {
        rating,
        defaultValue: `${rating}% satisfaction rating`,
      }),
    aboutCoach: (name) =>
      t('CoachChatList.about_coach', {
        name,
        defaultValue: `About ${name}`,
      }),
  }
}
